export const profileSvg = (color) => <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 57.04 57.04"
    className="h-8 w-8"
>
    <g>
        <path fill={color || "#000"} d="M28.52,0C12.77,0,0,12.77,0,28.52s12.77,28.52,28.52,28.52,28.52-12.77,28.52-28.52S44.27,0,28.52,0ZM28.52,8.69c5.65,0,10.24,4.58,10.24,10.24s-4.58,10.24-10.24,10.24-10.24-4.58-10.24-10.24h0c0-5.65,4.58-10.24,10.24-10.24ZM45.63,42.79c-7.88,9.45-21.93,10.73-31.38,2.85-1.03-.86-1.99-1.81-2.85-2.85-.57-.69-.79-1.61-.57-2.48.97-3.94,3.23-7.44,6.41-9.95.98-.77,2.34-.79,3.34-.05,2.12,1.57,4.89,2.53,7.93,2.53s5.81-.95,7.93-2.53c1-.74,2.37-.72,3.34.05,3.19,2.51,5.44,6.01,6.41,9.95.22.87,0,1.79-.56,2.48h0Z"/>
    </g>
</svg>;

export const copySvg = <svg
className="ml-2"
xmlns="http://www.w3.org/2000/svg"
width="14.391"
height="16.859"
viewBox="0 0 16.391 17.859"
>
<path
    id="copy-copy"
    d="M76.7-4.892H68.5a2.05,2.05,0,0,1-2.049-2.05V-16.6a2.05,2.05,0,0,1,2.049-2.05h8.2a2.05,2.05,0,0,1,2.049,2.05v9.658A2.05,2.05,0,0,1,76.7-4.892ZM77.72-16.6A1.025,1.025,0,0,0,76.7-17.626H68.5A1.025,1.025,0,0,0,67.476-16.6v9.658A1.025,1.025,0,0,0,68.5-5.918h8.2A1.025,1.025,0,0,0,77.72-6.943V-16.6ZM63.378-12.5v9.658A1.025,1.025,0,0,0,64.4-1.817h8.2a1.025,1.025,0,0,0,1.024-1.025V-3.867h1.024v1.025A2.05,2.05,0,0,1,72.6-.792H64.4a2.05,2.05,0,0,1-2.049-2.05V-12.5A2.05,2.05,0,0,1,64.4-14.55h1.024v1.025H64.4A1.025,1.025,0,0,0,63.378-12.5Z"
    transform="translate(-62.354 18.651)"
    fill="#16519e"
/>
</svg>;

export const coinSvg = (color) => <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 45.95 45.95"
    className="h-8 w-8"
>
    <defs>
        <linearGradient id="coin-linear-gradient" x1="0" y1="22.98" x2="45.95" y2="22.98" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor={color || "#fdc977"}/>
            <stop offset=".62" stopColor={color || "#feefd7"}/>
            <stop offset=".67" stopColor={color || "#faead0"}/>
            <stop offset=".73" stopColor={color || "#f0ddbe"}/>
            <stop offset=".81" stopColor={color || "#e1c8a1"}/>
            <stop offset=".9" stopColor={color || "#cbaa78"}/>
            <stop offset="1" stopColor={color || "#af8545"}/>
        </linearGradient>
        <linearGradient id="coin-linear-gradient-2" x1="3.26" y1="22.98" x2="42.7" y2="22.98" xlinkHref="#coin-linear-gradient"/>
    </defs>
    <g>
        <path fill="url(#coin-linear-gradient)" d="M22.98,0C10.29,0,0,10.29,0,22.98s10.29,22.98,22.98,22.98,22.98-10.29,22.98-22.98S35.67,0,22.98,0ZM22.98,43.2c-11.17,0-20.22-9.05-20.22-20.22S11.81,2.76,22.98,2.76s20.22,9.05,20.22,20.22-9.05,20.22-20.22,20.22Z"/>
        <path fill="url(#coin-linear-gradient-2)" d="M22.98,3.26C12.1,3.26,3.26,12.1,3.26,22.98s8.85,19.72,19.72,19.72,19.72-8.85,19.72-19.72S33.85,3.26,22.98,3.26ZM30.42,34.43l-7.44-5.41-7.44,5.41,2.84-8.75-7.44-5.41h9.2l2.84-8.75,2.84,8.75h9.2l-7.44,5.41,2.84,8.75Z"/>
    </g>
</svg>;

export const giftBoxSvg = (color) => <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 44.15 45.95"
    className="h-8 w-8"
>
    <defs>
        <linearGradient id="gift-linear-gradient" x1="0" y1="22.98" x2="44.15" y2="22.98" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor={color || "#fdc977"}/>
            <stop offset=".62" stopColor={color || "#feefd7"}/>
            <stop offset=".67" stopColor={color || "#faead0"}/>
            <stop offset=".73" stopColor={color || "#f0ddbe"}/>
            <stop offset=".81" stopColor={color || "#e1c8a1"}/>
            <stop offset=".9" stopColor={color || "#cbaa78"}/>
            <stop offset="1" stopColor={color || "#af8545"}/>
        </linearGradient>
    </defs>
    <g>
        <path fill="url(#gift-linear-gradient)" d="M20.26,26.25v19.16s0,.54-.51.54H4.58c-1.18,0-2.15-.97-2.15-2.15v-16.14c0-1.18.97-2.15,2.15-2.15h14.92c.76,0,.76.73.76.73ZM39.57,25.52h-14.91c-.91,0-.77.95-.77.95v18.97s0,.53.54.53h15.14c1.18,0,2.15-.97,2.15-2.15v-16.14c0-1.18-.97-2.15-2.15-2.15ZM20.26,12.82s0-.73-.72-.73H2.15c-1.18,0-2.15.97-2.15,2.15v6.71c0,1.18.97,2.15,2.15,2.15h17.45c.66,0,.66-.57.66-.57v-9.71h0ZM42,12.09h-17.44c-.66,0-.66.63-.66.63v9.82s0,.56.81.56h17.3c1.18,0,2.15-.97,2.15-2.15v-6.71c0-1.18-.97-2.15-2.15-2.15ZM17.81,9.89c2.13-.58,3.28-1.46,3.52-2.69.16-.84,0-2.2-3.28-4.4-1.94-1.3-4.1-2.27-5.8-2.6-.67-.13-1.29-.2-1.86-.2-2.7,0-4.47,1.45-4.98,4.09-.29,1.51-.07,2.8.68,3.86.83,1.17,2.2,1.94,4.21,2.33.79.15,1.69.23,2.67.23,1.65,0,3.43-.22,4.86-.61ZM11.58,3.58c1.93.38,4.24,1.75,5.5,2.78.12.07,0,.15-.06.17-.97.27-2.42.52-4.08.52-.75,0-1.45-.06-2.01-.17-1.04-.2-1.77-.53-2.05-.93-.07-.09-.27-.38-.11-1.21.2-1.01.56-1.3,1.6-1.3.35,0,.75.04,1.2.13ZM33.92,10.27c2-.39,3.38-1.15,4.21-2.33.74-1.05.97-2.35.67-3.86C38.29,1.45,36.52,0,33.82,0c-.57,0-1.2.07-1.86.2-1.69.33-3.86,1.3-5.8,2.6-3.28,2.2-3.45,3.57-3.28,4.4.24,1.23,1.39,2.11,3.52,2.69,1.44.39,3.21.61,4.86.61h0c.98,0,1.88-.08,2.67-.23ZM32.62,3.58c.45-.09.85-.13,1.2-.13,1.05,0,1.4.29,1.6,1.3.16.83-.04,1.11-.11,1.21-.28.4-1.01.73-2.05.93-.56.11-1.26.17-2.01.17-1.67,0-3.14-.26-4.11-.53-.06-.02-.11-.12,0-.18,1.26-1.03,3.55-2.38,5.47-2.76Z"/>
    </g>
</svg>;